import { render, staticRenderFns } from "./RegistrationFarmAndVehicleForm.vue?vue&type=template&id=15ea926a&"
import script from "./RegistrationFarmAndVehicleForm.vue?vue&type=script&lang=ts&"
export * from "./RegistrationFarmAndVehicleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports